import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { AccountCustomerAssistant } from '../../containers/AccountCustomerAssistant';

export const AdminAccountCustomerAssistantPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<AccountCustomerAssistant />
		</AdminDashboardPageLayout>
	);
};
